import { IStack } from './stack.model';
import StackView from './stack.view';

const StackController = (props: IStack): JSX.Element => {
  return <StackView {...props} />;
};

export default StackController;
